import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumCompanyType, EnumCompanyTypeOption } from "./EnumCompanyType";
import DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordMethod from "./DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordMethod";
import DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordInnerAccompanyPerson from "./DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordInnerAccompanyPerson";
import DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordContent from "./DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordContent";
import DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordFile from "./DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordFile";
import { EnumCompanyFollowUpRecordStatus, EnumCompanyFollowUpRecordStatusOption } from "./EnumCompanyFollowUpRecordStatus";
import UiGroup from "./UiGroup";

/**
 * 跟进记录表单
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFormCompanyFollowUpRecord extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.Methods = [];
        this.InnerAccompanyPeople = [];
        this.Contents = [];
        this.Files = [];
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 公司类型
     */
    CompanyType?: EnumCompanyType;
    /**
     * 计划编号
     */
    Code?: string;
    /**
     * 客户企业Id
     */
    CustomerId?: string;
    /**
     * 客户企业
     */
    CustomerLabel?: string;
    /**
     * 跟进方式
     */
    Methods?: DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordMethod[];
    /**
     * 跟进人
     */
    FollowUpPersonId?: string;
    /**
     * 跟进人
     */
    FollowUpPersonLabel?: string;
    /**
     * 计划跟进时间
     */
    PlanFollowUpTime?: Date;
    /**
     * 计划完成时间
     */
    PlanCompleteTime?: Date;
    /**
     * 地点
     */
    AreaLabel?: string;
    /**
     * 详细地址
     */
    Address?: string;
    /**
     * 对方参与人员
     */
    CustomerJoinPerson?: string;
    /**
     * 内部陪同人员
     */
    InnerAccompanyPeople?: DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordInnerAccompanyPerson[];
    /**
     * 外部陪同人
     */
    OuterAccompanyPerson?: string;
    /**
     * 第三方参与人员
     */
    ThreeJoinPerson?: string;
    /**
     * 跟进内容
     */
    Contents?: DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordContent[];
    /**
     * 跟进内容描述
     */
    Description?: string;
    /**
     * 附件
     */
    Files?: DtoFormCompanyFollowUpRecord_CompanyFollowUpRecordFile[];
    /**
     * 超链接文本
     */
    LinkLabel?: string;
    /**
     * 超链接
     */
    Link?: string;
    /**
     * 状态
     */
    Status?: EnumCompanyFollowUpRecordStatus;
}

/**
 * 跟进记录表单-表单校验
 */
export const DtoFormCompanyFollowUpRecordRules = {
    CustomerLabel: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "blur",
        },
        {
            max: 1024,
            message: "文本长度不能超过 1024 个字符",
            trigger: "blur",
        },
    ],
    Methods: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
            type: "array",
        },
    ],
    FollowUpPersonId: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
    PlanFollowUpTime: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
    AreaLabel: [
        {
            max: 1024,
            message: "文本长度不能超过 1024 个字符",
            trigger: "blur",
        },
    ],
    Address: [
        {
            max: 1024,
            message: "文本长度不能超过 1024 个字符",
            trigger: "blur",
        },
    ],
    CustomerJoinPerson: [
        {
            max: 1024,
            message: "文本长度不能超过 1024 个字符",
            trigger: "blur",
        },
    ],
    OuterAccompanyPerson: [
        {
            max: 1024,
            message: "文本长度不能超过 1024 个字符",
            trigger: "blur",
        },
    ],
    ThreeJoinPerson: [
        {
            max: 1024,
            message: "文本长度不能超过 1024 个字符",
            trigger: "blur",
        },
    ],
    Description: [
        {
            max: 10240,
            message: "文本长度不能超过 10240 个字符",
            trigger: "blur",
        },
    ],
    Link: [
        {
            max: 10240,
            message: "文本长度不能超过 10240 个字符",
            trigger: "blur",
        },
    ],
    Status: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
}

/**
 * 跟进记录表单-设置项
 */
export const DtoFormCompanyFollowUpRecordMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "CustomerLabel",
    Label: "客户企业",
    Customize: true,
  },
  {
    Prop: "Methods",
    Label: "跟进方式",
    Customize: true,
  },
  {
    Prop: "FollowUpPersonId",
    Label: "跟进人",
    Customize: true,
  },
  {
    Prop: "PlanFollowUpTime",
    Label: "计划跟进时间",
    Customize: true,
  },
  {
    Prop: "PlanCompleteTime",
    Label: "计划完成时间",
    Customize: true,
  },
  {
    Prop: "AreaLabel",
    Label: "地点",
    Customize: true,
  },
  {
    Prop: "Address",
    Label: "详细地址",
    Type: EnumMiezzFormItemType.InputText,
  },
  {
    Prop: "CustomerJoinPerson",
    Label: "对方参与人员",
    Type: EnumMiezzFormItemType.InputText,
  },
  {
    Prop: "InnerAccompanyPeople",
    Label: "内部陪同人员",
    Customize: true,
  },
  {
    Prop: "OuterAccompanyPerson",
    Label: "外部陪同人",
    Type: EnumMiezzFormItemType.InputText,
  },
  {
    Prop: "ThreeJoinPerson",
    Label: "第三方参与人员",
    Type: EnumMiezzFormItemType.InputText,
  },
  {
    Prop: "Contents",
    Label: "跟进内容",
    Customize: true,
  },
  {
    Prop: "Description",
    Label: "跟进内容描述",
    Type: EnumMiezzFormItemType.AreaText,
  },
  {
    Prop: "Files",
    Label: "附件",
    Customize: true,
  },
  {
    Prop: "Link",
    Label: "超链接",
    Customize: true,
  },
  {
    Prop: "Status",
    Label: "状态",
    Type: EnumMiezzFormItemType.Select,
    Options: EnumCompanyFollowUpRecordStatusOption,
  },
]
